import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=1c4e03a1&scoped=true&"
import script from "./ProfileItem.vue?vue&type=script&lang=js&"
export * from "./ProfileItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileItem.vue?vue&type=style&index=0&id=1c4e03a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e03a1",
  null
  
)

export default component.exports